import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { Editor } from "components/shared/Editor";
import { addBlog, getBlogCategories, getTags } from "store/actions";
import { useNavigate } from "react-router-dom";
import server from "api/server";
import imageUpload from "assets/svgs/imageUpload.svg";
import CreatableSelect from "react-select/creatable";
import { getId } from "helpers/functions";
import FeaturesArray from "views/services/FeaturesArray";
import ImageUpload from "components/shared/ImageUpload";

const AddBlog = () => {
  const [selectedImage, setSelectedImage] = useState();
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { locale, formatMessage } = useIntl();
  const dir = locale === "ar" ? "rtl" : "ltr";

  const { blogCategories } = useSelector((state) => state.blogCategories);
  // const { languages } = useSelector((state) => state.languages);

  const { blogTags } = useSelector((state) => state.blogs) || {};

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const { fields, append, remove, update } = useFieldArray({
    control,
    name: "contents",
  });

  // const renderLanguagesSelectOptions = () => {
  //   return languages.map((language, index) => {
  //     return (
  //       <option value={getId(language)} key={index}>
  //         {language?.name}
  //       </option>
  //     );
  //   });
  // };

  const imageChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const { data } = await server().post("/upload", formData);
      setSelectedImage({
        preview: e.target.files[0],
        path: data.data.files[0].path,
      });
    }
  };

  const removeSelectedImage = () => {
    setSelectedImage();
  };

  useEffect(() => {
    dispatch(getBlogCategories());
    // dispatch(getTags());
  }, [dispatch]);

  const renderCategoriesOptions = blogCategories?.map((category) => (
    <option value={getId(category)}>{category?.title?.[locale]}</option>
  ));

  const onSubmit = (data) => {
    if (selectedImage && selectedImage.path) data["image"] = selectedImage.path;
    data.image = "uploads/" + data?.image?.split("/").pop();
    data.description = description;
    data.tags = tags;

    dispatch(addBlog({ data, navigate }));
  };
  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id="addBlog" />
            </h4>
          </div>
          <div className="card-body form-group settings-tabs">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  <Col lg={12}>
                    <div className="form-group required">
                      <h5>صورة المقال</h5>
                      <ImageUpload
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                        accept="image/*, video/*"
                      />
                    </div>
                  </Col>
                  <Col xs={12}>
                    <div className="form-group required">
                      <h5>التصنيف</h5>
                      <div>
                        <select
                          className="form-control"
                          {...register("category", { required: true })}
                        >
                          <option>اختر التصنيف</option>
                          {renderCategoriesOptions}
                        </select>
                      </div>
                      <p className="error-hint">
                        {errors.category?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>

                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="title" /> (
                        <FormattedMessage id="arabic" />)
                      </h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          {...register("title.ar", {
                            required: true,
                          })}
                        />
                      </div>
                      <p className="error-hint">
                        {errors.title?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="title" /> (
                        <FormattedMessage id="english" />)
                      </h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          {...register("title.en", {
                            required: true,
                          })}
                        />
                      </div>
                      <p className="error-hint">
                        {errors.title?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>

                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="description" /> (
                        <FormattedMessage id="arabic" />)
                      </h5>
                      <div>
                        <Controller
                          control={control}
                          name="description.ar"
                          render={({ field: { value } }) => (
                            <Editor
                              initialValue=""
                              onChange={(e, editor) => {
                                const data = editor.getContent();
                                setDescription({
                                  ...description,
                                  ar: data,
                                });
                              }}
                              tinymceScriptSrc="https://cdn.tiny.cloud/1/qagffr3pkuv17a8on1afax661irst1hbr4e6tbv888sz91jc/tinymce/5-stable/tinymce.min.js"
                            />
                          )}
                        />
                        <p className="error-hint">
                          {errors.description?.ar?.type === "required" && (
                            <FormattedMessage id="required" />
                          )}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="description" /> (
                        <FormattedMessage id="english" />)
                      </h5>
                      <div>
                        <Controller
                          control={control}
                          name="description.en"
                          render={({ field: { value } }) => (
                            <Editor
                              initialValue=""
                              onChange={(e, editor) => {
                                const data = editor.getContent();
                                setDescription({
                                  ...description,
                                  en: data,
                                });
                              }}
                              tinymceScriptSrc="https://cdn.tiny.cloud/1/qagffr3pkuv17a8on1afax661irst1hbr4e6tbv888sz91jc/tinymce/5-stable/tinymce.min.js"
                            />
                          )}
                        />
                        <p className="error-hint">
                          {errors.description?.en?.type === "required" && (
                            <FormattedMessage id="required" />
                          )}
                        </p>
                      </div>
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id="keywords" />
                      </h5>
                      <div>
                        <Controller
                          control={control}
                          name="tags"
                          render={({
                            field: { onChange, value, selected },
                          }) => (
                            <CreatableSelect
                              isMulti
                              isRtl={true}
                              className="basic-single creatable-select"
                              classNamePrefix="select"
                              placeholder="اضف كلمات دلالية"
                              onChange={(selected) => {
                                const newTags = selected.map(
                                  (tag) => tag.label
                                );

                                setTags(newTags);
                              }}
                              options={blogTags.map((tag) => ({
                                value: tag,
                                label: tag,
                              }))}
                            />
                          )}
                        />
                      </div>
                      <p className="error-hint">
                        {errors.tags?.type === "required" &&
                          "يرجي ادخال الكلمات الدلالية"}
                      </p>
                    </div>
                  </Col>
                </Row>
                {/* <FeaturesArray
                  {...{
                    register,
                    errors,
                    fields,
                    append,
                    remove,
                    update,
                    name: "contents",
                  }}
                /> */}
              </Col>

              <Col lg={4} xs={12}>
                <div className="form-group mt-3">
                  <button type="submit" className="btn btn-blue">
                    <FormattedMessage id="add" />
                  </button>
                </div>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBlog;
